import React, { CSSProperties, FC } from 'react';

import { AppLayoutBreakpoint, useContainerWidth } from '../../../../util/responsiveness';

import { getInlineStyles, useClassNames } from './MainAreaHeroBackground.styles';
import { MainAreaHeroBackgroundProps } from './MainAreaHeroBackground.types';

const MainAreaHeroBackground: FC<MainAreaHeroBackgroundProps> = ({ children, imgSrc }) => {
  const containerWidth = useContainerWidth();
  const isWide = containerWidth >= AppLayoutBreakpoint.Width812;

  const classNames = useClassNames({
    isWide,
  });

  const inlineStyles = getInlineStyles({
    imgSrc,
  }) as CSSProperties;

  return (
    <div className={classNames.mainAreaHeroBackground} style={inlineStyles}>
      {children}
    </div>
  );
};

export default MainAreaHeroBackground;
